import React from 'react';
import { useHybridAuth } from '../HybridAuthProvider';

interface NoAccountProps {
  userEmail?: string;
}

const NoAccount: React.FC<NoAccountProps> = ({ userEmail }) => {
  const { logout } = useHybridAuth();

  const handleLogout = () => {
    logout();
  };

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '100vh',
        padding: '2rem',
        textAlign: 'center',
        backgroundColor: '#f5f5f5',
      }}
    >
      <div
        style={{
          backgroundColor: 'white',
          borderRadius: '8px',
          padding: '3rem',
          maxWidth: '600px',
          boxShadow: '0 2px 10px rgba(0,0,0,0.1)',
        }}
      >
        <h1 style={{ color: '#2c3e50', marginBottom: '1.5rem' }}>Welcome to HabiTrack</h1>

        <div style={{ marginBottom: '2rem' }}>
          <svg width="80" height="80" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm-1-13h2v6h-2zm0 8h2v2h-2z"
              fill="#3498db"
            />
          </svg>
        </div>

        <h2 style={{ color: '#7f8c8d', fontWeight: 'normal', marginBottom: '1rem' }}>No Account Found</h2>

        {userEmail && (
          <p style={{ color: '#95a5a6', marginBottom: '2rem' }}>
            {userEmail}
          </p>
        )}

        <div
          style={{
            backgroundColor: '#ecf0f1',
            borderRadius: '4px',
            padding: '1.5rem',
            marginBottom: '2rem',
            textAlign: 'left',
          }}
        >
          <p style={{ marginBottom: '1rem', color: '#2c3e50' }}>
            Thank you for your interest in HabiTrack! It appears you don't have an account with us yet.
          </p>

          <p style={{ marginBottom: '1rem', color: '#2c3e50' }}>
            HabiTrack is an enterprise habit-tracking platform designed to help organizations build better workplace
            cultures through positive habit formation.
          </p>

          <p style={{ color: '#2c3e50' }}>
            If you believe you should have access, please contact your HR department or programme administrator.
          </p>
        </div>

        <div style={{ marginTop: '2rem' }}>
          <button
            onClick={handleLogout}
            style={{
              backgroundColor: '#3498db',
              color: 'white',
              padding: '12px 24px',
              borderRadius: '4px',
              border: 'none',
              fontWeight: '500',
              cursor: 'pointer',
              marginRight: '1rem',
            }}
          >
            Login as Different User
          </button>

          <a
            href="https://www.fabricshift.com/"
            target="_blank"
            rel="noopener noreferrer"
            style={{
              display: 'inline-block',
              backgroundColor: '#95a5a6',
              color: 'white',
              padding: '12px 24px',
              borderRadius: '4px',
              textDecoration: 'none',
              fontWeight: '500',
            }}
          >
            Learn More About FabricShift
          </a>
        </div>
      </div>
    </div>
  );
};

export default NoAccount;
